import React, { useCallback, useContext } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { ConfirmationDialog } from "../../../../../../../components/dialog/ConfirmationDialog"
import { TabEnum } from "../../../../../../../components/tabs/tabs"
import { BSLevelContext } from "../../building/BSCreateBuildingPages/BSZoneAndLevelPage/context/BSLevelContext"
import { ErrorContext } from "../../../../../../../components/layout/error-snackbar"

interface IProps {
  openWarningDialog: boolean
  setOpenWarningDialog: React.Dispatch<React.SetStateAction<boolean>>
  setIsUpdating: React.Dispatch<React.SetStateAction<boolean>>
  selectedTab: TabEnum
  setSelectedTab: React.Dispatch<React.SetStateAction<TabEnum>>
  tmpSelectedTabRef: React.MutableRefObject<TabEnum>
  tmpTargetUrlRef: React.MutableRefObject<string>
  modeRef: React.MutableRefObject<"tab" | "url">
  setUrl(index: TabEnum, bsBuildingId?: string): void
}

export function WarningUpdatedDialog({
  openWarningDialog,
  setOpenWarningDialog,
  setIsUpdating,
  selectedTab,
  setSelectedTab,
  setUrl,
  tmpSelectedTabRef,
  tmpTargetUrlRef,
  modeRef,
}: Readonly<IProps>): React.JSX.Element {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const openErrorSnackbar = useContext(ErrorContext)
  const { refreshBuildingLevel } = useContext(BSLevelContext)

  const validateTabNavigation: () => void = useCallback(() => {
    const buildingId = searchParams.get("bsBuildingId") ?? undefined

    if (selectedTab === TabEnum.BUILDING_LEVEL) {
      refreshBuildingLevel()
    }
    setIsUpdating(false)
    setSelectedTab(tmpSelectedTabRef.current)
    setUrl(tmpSelectedTabRef.current, buildingId)
  }, [refreshBuildingLevel, searchParams, selectedTab, setIsUpdating, setSelectedTab, setUrl, tmpSelectedTabRef])

  const validateUrlNavigation: () => void = useCallback(() => {
    navigate(tmpTargetUrlRef.current)
  }, [navigate, tmpTargetUrlRef])

  const validate: () => Promise<any> = useCallback(() => {
    if (modeRef.current === "tab") {
      validateTabNavigation()
    } else if (modeRef.current === "url") {
      validateUrlNavigation()
    } else {
      openErrorSnackbar(new Error("Pas de destination sélectionné"))
    }
    return Promise.resolve()
  }, [modeRef, openErrorSnackbar, validateTabNavigation, validateUrlNavigation])

  return (
    <ConfirmationDialog
      id=""
      title="Attention"
      contentText="Les informations n'ont pas été enregistrés. Êtes vous sûr de vouloir continuer ?"
      handleClose={() => setOpenWarningDialog(false)}
      action={validate}
      open={openWarningDialog}
    />
  )
}
